import service from '@/services/SICUDgpd_crd_mail';

export default {
  namespaced: true,

  actions: {
    /**
     * Petición para obtener labels registrados en Integrity que serán utilizados en una vista.
     */
    async update({ dispatch, rootGetters }, event) {
      return new Promise((resolve, reject) => {
        const payload = {
          dsSICUDgpd_est_crd: {
            eeDatos: [rootGetters['auth/state']],
            eegpd_est_crd: [
              {
                doc_num: rootGetters['SICUDgpd_est_crd/state'].numberDocument || 0, // default,
                piicod_otp: atob(rootGetters['SIRcon_aut/state'].codeVerify),
                crd_cel: event.phone,
                crd_mail: event.email,
              },
            ],
          },
        };

        let notification;

        service.put(payload)
          .then((response) => {
            const data = response.data.dsSICUDgpd_est_crd;

            if (data.eeEstados[0].Returnid === 0) {
              resolve(data.eegpd_est_crd[0]);
            } else if (data.eeEstados[0].Returnid === 98) {
              resolve([]);
            } else {
              notification = {
                code: data.eeEstados[0].Returnid,
                message: data.eeEstados[0].Estado,
                timestamp: Date.now(),
                type: 'error',
              };

              throw notification;
            }
          })
          .catch((error) => {
            if (error.type === undefined) {
              notification = {
                code: undefined,
                message: error.message,
                timestamp: Date.now(),
                type: 'error',
              };
            }

            dispatch('notification/create', notification, {
              root: true,
            });

            reject(notification);
          });
      });
    },
  },
};
